import {JsonObject} from "../shared/json/json-object";
import {JsonProperty} from "../common/json/json-property";
import {FormGen} from "../shared/formgen";
import {Type} from "../common/json/helpers";
import {$KTS, KeyTextStrings} from "../common/keytext";
import {ObjectConfig, TypedObject} from "../shared/types";

export enum MysmileCodeOptionsSize {
  A4 = "a4",
  LETTER = "letter",
}

export const MYSMILE_CODE_OPTIONS_SIZE_KTS = new KeyTextStrings([
  $KTS(MysmileCodeOptionsSize.A4, "A4"),
  $KTS(MysmileCodeOptionsSize.LETTER, "Letter"),
]);

@JsonObject()
export class MysmileCodeOptions {

  @FormGen({
    name: "Size",
    type: "enum",
    enumValues: MYSMILE_CODE_OPTIONS_SIZE_KTS.values,
  })
  @JsonProperty()
  size: string = MysmileCodeOptionsSize.A4;
}

export enum MysmileCustomizeOptionsFormFields {
  NAME = "name",
  EMAIL = "email",
  PHONE = "phone",
  ADDRESS = "address",
}

export const MYSMILE_CUSTOMIZE_OPTIONS_SIZE_KTS = new KeyTextStrings([
  $KTS(MysmileCustomizeOptionsFormFields.NAME, "Name"),
  $KTS(MysmileCustomizeOptionsFormFields.EMAIL, "Email"),
  $KTS(MysmileCustomizeOptionsFormFields.PHONE, "Phone"),
  $KTS(MysmileCustomizeOptionsFormFields.ADDRESS, "Address"),
]);

@JsonObject()
export class MysmileCustomizeOptions extends TypedObject {

  readonly id: string = "mysmile/customize";

  @JsonProperty()
  enabled: boolean = true;

  @FormGen({
    name: "Display Name",
    type: "string",
    autoFocus: false,
    required: true,
  })
  @JsonProperty()
  displayName: string;

  @FormGen({
    name: "Profile Photo",
    type: "profile_photo",
  })
  @JsonProperty()
  profilePhoto: string;

  @FormGen({
    name: "Include fields",
    type: "enum",
    required: true,
    enumMulti: true,
    enumValues: MYSMILE_CUSTOMIZE_OPTIONS_SIZE_KTS.values,
  })
  @JsonProperty()
  fields: string[] = [MysmileCustomizeOptionsFormFields.NAME, MysmileCustomizeOptionsFormFields.EMAIL, MysmileCustomizeOptionsFormFields.PHONE];

  static async load(practiceId: string): Promise<MysmileCustomizeOptions> {
    const obj = new MysmileCustomizeOptions(practiceId);
    await obj.load();
    return obj;
  }

  constructor(readonly practiceId: string) {
    super(null, null);
  }

  protected objectConfig(): ObjectConfig | null {
    return {
      shared: true,
    };
  }

  protected basePath(): string | null {
    return `practiceData/${this.practiceId}`;
  }

  protected getType(): Type<any> {
    return MysmileCustomizeOptions;
  }
}

export class Mysmile {

  static getInstance(): Mysmile {
    return globalThis.Mysmile;
  }

  static async loadInstance(practiceId: string): Promise<void> {
    if (globalThis.Mysmile) {
      return;
    }
    globalThis.Mysmile = new Mysmile(
      practiceId,
      await MysmileCustomizeOptions.load(practiceId),
    );
  }

  constructor(
    readonly practiceId: string,
    readonly customizeOptions: MysmileCustomizeOptions,
  ) {
  }
}